//export * from './wsRegVino'
export * from '../interfaces/web-api-csharp'